import React, { useState, useEffect } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  Typography,
  TableContainer,
} from "@mui/material";
import VantageListHead from "../../../../component/ListHead/SignalList";
import {
  Tablecell,
  applySortFilter,
  calculateAndFormatNoAbs,
  getComparator,
  hashAction,
  hashPosition,
} from "../../../../component/Methods";
import { getValidatedTableStyles, getCellStyle } from "../../styles/rebalancerStyles";

const Order = ({ orders, tableHeader, brokers }) => {
  const theme = useTheme();
  const styles = getValidatedTableStyles(theme);
  const [data, setData] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("strategy");



  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    if (orders) {
      const formattedData = Object?.entries(orders)?.flatMap(([parentStrategy, positions]) => {
        if (Array.isArray(positions)) {
          return positions.map(position => ({
            brokerName: brokers?.find(broker => broker?.brokerId === position?.broker)?.abbreviation,
            Pstrategy: parentStrategy,
            tradeType: hashAction(position?.action) + hashPosition(position?.position),
            ...position,
          }));
        }
        return [{
          brokerName: brokers?.find(broker => broker?.brokerId === positions?.broker)?.abbreviation,
          Pstrategy: parentStrategy,
          tradeType: hashAction(positions?.action) + hashPosition(positions?.position),
          ...positions,
        }];
      });

      
      
      const filteredUsers = applySortFilter(
        formattedData,
        getComparator(order, orderBy)
      );
      setData(filteredUsers);
    }
  }, [order, orderBy, orders]);

 

  return (
    <>
      <Box sx={styles.section}>
        <Typography sx={styles.title}>Order Generated by Crossing</Typography>

        <TableContainer sx={styles.tableContainer}>
          <Table
            size="small"
            stickyHeader
            aria-label="a dense table"
            sx={styles.table}
          >
            <VantageListHead
              order={order}
              orderBy={orderBy}
              headLabel={tableHeader}
              noStatus={true}
              customizeFont={12}
              rowCount={data.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {data?.map((row, index) => (
                <TableRow key={index} sx={styles.row}>
                  <Tablecell align="left" style={getCellStyle(theme, "left")}>
                    {row?.Pstrategy}
                  </Tablecell>
                  <Tablecell align="right" style={getCellStyle(theme, "right")}>
                    {calculateAndFormatNoAbs(row?.shareCount)}
                  </Tablecell>
                  <Tablecell align="right" style={getCellStyle(theme, "right")}>
                    {row?.tradeType}
                  </Tablecell>
                  <Tablecell align="right" style={getCellStyle(theme, "right")}>
                    {row?.custodian}
                  </Tablecell>
                  <Tablecell align="right" style={getCellStyle(theme, "right")}>
                    {row?.brokerName}
                  </Tablecell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default Order;
